var _path, _rect, _rect2, _path2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoftwareDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "My Software") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35,21V65H75V21ZM73,63H37V23H73Z",
    transform: "translate(-35 -21)",
    fill: "#b4ccdd"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 51.59,
    y: 36.5,
    width: 15.99,
    height: 19.71,
    transform: "translate(84.17 71.71) rotate(180)",
    fill: "#b4ccdd"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.92,
    y: 15.5,
    width: 8.67,
    height: 19.71,
    fill: "#05548e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.54,29.25V57.5h27V29.25Zm25,26.25h-23v-18h23Z",
    transform: "translate(-35 -21)",
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.37,
    y: 11.05,
    width: 22.83,
    height: 2.65,
    fill: "#05548e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftwareDefault);
export default __webpack_public_path__ + "static/media/software-default.d22e621ee3f0460e80e8a36847015386.svg";
export { ForwardRef as ReactComponent };